/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadWishLists,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { xngLoadWishListsTotal } from "@plumberssupply/App/Services/WishListService";

export interface WishListTotalModel {
    wishListId: string;
    total: string;
}

export const XngLoadWishListsTotal: typeof DispatchCompleteLoadWishLists = async props => {
    const wishListIds = props.apiResult.wishListCollection?.map(w => w.id);
    if (wishListIds) {
        const result = await xngLoadWishListsTotal({ wishListIds });
        props.apiResult.wishListCollection = props.apiResult.wishListCollection?.map(wishlist => ({
            ...wishlist,
            name: wishlist.properties.plumbers_wishListName || wishlist.name,
            properties: {
                ...wishlist.properties,
                total: result.filter(o => wishlist.id === o.wishListId)[0]?.total ?? 0,
            },
        }))!;
    }
};

addToChainBefore(chain, DispatchCompleteLoadWishLists, XngLoadWishListsTotal);
